module.exports = __webpack_public_path__ + "media/images/icons/icon-stop-b2420e528bd42c83c34b45d1bd7bf2b7.svg";